import { useCallback, useEffect, useState } from 'react'

export type Tema = 'claro' | 'oscuro'

const CLAVE = 'minimarket.tema'

function leerGuardado(): Tema | null {
    try {
        const valor = localStorage.getItem(CLAVE)
        return valor === 'claro' || valor === 'oscuro' ? valor : null
    } catch {
        // Modo privado o almacenamiento bloqueado: se opera sin recordar.
        return null
    }
}

/**
 * Tema inicial: lo que el usuario eligio antes y, si nunca eligio, lo que
 * prefiere el sistema. Una vez que elige, su decision manda para siempre: el
 * equipo de la caja suele estar configurado por otra persona.
 */
export function temaInicial(): Tema {
    const guardado = leerGuardado()

    if (guardado) return guardado

    try {
        return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'oscuro' : 'claro'
    } catch {
        return 'claro'
    }
}

export function aplicarTema(tema: Tema) {
    document.documentElement.dataset.tema = tema
}

/**
 * Se aplica al cargar el modulo, antes de que React dibuje nada: si se hiciera
 * dentro de un efecto, la primera pintura saldria con el tema equivocado y se
 * veria el parpadeo.
 */
aplicarTema(temaInicial())

export function usarTema(): { tema: Tema; alternar: () => void } {
    const [tema, setTema] = useState<Tema>(temaInicial)

    useEffect(() => {
        aplicarTema(tema)

        try {
            localStorage.setItem(CLAVE, tema)
        } catch {
            // Sin persistencia, el tema dura lo que dure la pestania.
        }
    }, [tema])

    const alternar = useCallback(
        () => setTema((actual) => (actual === 'claro' ? 'oscuro' : 'claro')),
        [],
    )

    return { tema, alternar }
}
